import React from "react";

import {AccountInfo,
    AccountAddSection,
    AccountNotes,
    AccountInput,
    AccountNumberInput,
    PaymentTypeSelect,
    AccountInfoButtons,
    AccountDisplay,
    buildAddAccountAjaxUrl,
    AccountEntryHelpModal,
    preAccountAjaxLookupValidation} from "./account-info";
import ShoppingCartPaymentWrapper from "../components/shopping-cart-payment-wrapper";
import ShoppingCartPaymentItems from "../components/shopping-cart-payment-items";
import ShoppingCartBillSummary from "../components/shopping-cart-bill-summary";    

import {AgentCenter} from "../components/payment-preference";

import {ContactInfoSection,
        ContactInfoEmail, ContactInfoName, ContactInfoPhoneAndZip} from "./contact-info";
import {PaymentInfo,
    PaymentInfoHeader,
    PaymentInfoBody,
    ShoppingCart,
    SinglePay} from "./payment-info";

import PaymentMethodCashFields from "./payment-method/payment-method-cash-fields";
import PaymentMethodCardPresentFields from "./payment-method/payment-method-card-present-fields"
import PaymentMethodWalletFields from "./payment-method/payment-method-wallet-fields"
import PaymentMethodLastUsedFields from "./payment-method/payment-method-last-used-fields"
import PaymentMethodCCFields from "./payment-method/payment-method-cc-fields"
import PaymentMethodDCFields from "./payment-method/payment-method-dc-fields"
import PaymentMethodDDFields from "./payment-method/payment-method-dd-fields"
import PaymentMethodPDFields from "./payment-method/payment-method-pd-fields"

import {
    CardHolderName
} from "../lib/payment-method-util";
import {
    PaymentMethodInfo,
    PaymentMethodIVRFields,
    BankAccountHolderName,
    CheckAccountHolderName,
    PaymentMethodCategory
} from "./payment-method-info";

import {
    AccountsTable,
    ControlButtons
} from './accounts-table';
import {LiabilitySummaryWidget} from "./liability-summary-widget";
import ReviewPayment from "./review-payment";
import {Receipt} from "./receipt";
import {populatePayment, preparePaymentForSubmission, postProcessSuccessfulPayment, createNewPayment, formatAccountNumber} from "../lib/payment-utils";
import RegisteredUsers from "./registered-users";
import IvrStageDialog from "./ivr-stage-dlg";
import StagingReviewPayment from './staging-ivr-review';
import ReviewPaymentTransactionList from './review-payment-transaction-list';
import ReviewPaymentTotalAmount from './review-payment-total-amount';
import CardPresentInteractionModal from './card-present-interaction-modal';
import AgentCenterDialog from './agent-center-dlg';
import PaymentComponentsView from './payment-components-view';
import ReviewPaymentButtons from './review-payment-buttons'

/**
 * Popup modals
 */
import DeleteDialog from "./delete-dlg";
import CancelDialog from "./cancel-dlg";
import AcceptAccountDialog from "./accept-account-dlg";
import SessionTimeoutWidget from "../lib/session-timeout-widget";

const PageWrapper = ({config, reactElements}) => {
    const {messages} = config;
    return (
        <React.Fragment>
            <h2 className="opp-page-title">{messages["opp.pageTitle"]}</h2>
            {reactElements}
        </React.Fragment>
    )
};

const RoppPageWrapper = ({config, reactElements}) => {
    return (
        <React.Fragment>
            {reactElements}
        </React.Fragment>
    )
};

const defaultComponents = {
    //Agent center display at top of page
    AgentCenter,
    // account section
    AccountInfo,
    AccountAddSection,
    AccountNotes,
    AccountInput,
    AccountNumberInput,
    PaymentTypeSelect,
    AccountInfoButtons,
    AccountDisplay,
    AccountEntryHelpModal,
    buildAddAccountAjaxUrl,
    preAccountAjaxLookupValidation,
    // payment info section
    PaymentInfo,
    PaymentInfoHeader,
    PaymentInfoBody,
    ShoppingCart,
    SinglePay,
    // contact info section
    ContactInfoSection,
    ContactInfoEmail,
    // payment method section
    PaymentMethodInfo,
    PaymentMethodCashFields,
    PaymentMethodCardPresentFields,
    PaymentMethodLastUsedFields,
    PaymentMethodCCFields,
    PaymentMethodDCFields,
    PaymentMethodDDFields,
    PaymentMethodPDFields,
    PaymentMethodIVRFields,
    PaymentMethodWalletFields,
    BankAccountHolderName,
    CardHolderName,
    CheckAccountHolderName,
    PaymentMethodCategory,
    CardPresentInteractionModal,
    AgentCenterDialog,
    // review payment section
    ReviewPayment,
    StagingReviewPayment,
    ReviewPaymentTransactionList,
    ReviewPaymentTotalAmount,
    ReviewPaymentButtons,
    // receipt section
    Receipt,
    PageWrapper,
    RoppPageWrapper,
    populatePayment,
    RegisteredUsers,
    IvrStageDialog,
    preparePaymentForSubmission,
    postProcessSuccessfulPayment,
    createNewPayment,
    DeleteDialog,
    CancelDialog,
    AcceptAccountDialog,
    SessionTimeoutWidget,
    PaymentComponentsView,
    AccountsTable,
    ControlButtons,
    LiabilitySummaryWidget,
    ContactInfoName,
    ContactInfoPhoneAndZip,
    ShoppingCartPaymentWrapper,
    ShoppingCartBillSummary,
    ShoppingCartPaymentItems,
    formatAccountNumber
};

export default defaultComponents;